import React from "react";
import {
  ActionButton,
  StepIndicatorHeader,
  HorizontalDatePicker,
} from "../../shared";

interface DatePickerProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
  onContinue?: () => void;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  selectedDate,
  onDateChange,
  onContinue,
}) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <StepIndicatorHeader
        stepNumber={1}
        title="Selecionar Data"
        description="Escolha o dia para seu agendamento"
      />

      <div className="max-w-2xl mx-auto">
        <HorizontalDatePicker
          selectedDate={selectedDate}
          onDateChange={onDateChange}
        />
      </div>

      {/* Continue Button - Show when date is selected */}
      {selectedDate && onContinue && (
        <div className="mt-8 text-center">
          <ActionButton
            onClick={onContinue}
            variant="primary"
            size="md"
            className="inline-flex items-center gap-2"
          >
            Continuar
            <span className="text-lg">→</span>
          </ActionButton>
        </div>
      )}
    </div>
  );
};
